import * as types from "../types_user";
import axios from "axios/index";
import authHeader from "../../authHeader";

const state = {
  admin: {
    isLoading: false,
    isError: false,
    currUser: null,
    allOrgs: [],
    allConsortia: [],
    selectedOrg: null,
  },
};

const getters = {
  isError: (state) => {
    return state.admin.isError;
  },
  isLoading: (state) => {
    return state.admin.isLoading;
  },
  currUser: (state) => {
    return state.admin.currUser;
  },
  allOrgs: (state) => {
    return state.admin.allOrgs;
  },
  allConsortia: (state) => {
    return state.admin.allConsortia;
  },
};

const actions = {
  setCurrUser: (context, payload) => {
    context.state.admin.currUser = payload;
  },
  setAllOrgs: (context, payload) => {
    console.log("ACTION: setAllOrgs");
    context.state.admin.isLoading = true;
    context.state.admin.isError = false;
    axios
      .get("/party/orgs", { headers: authHeader() })
      .then((response) => {
        let allOrgs = response.data || [];
        let currUser = payload;
        if (currUser.role == "Librarian") {
          let assocPartyIds = currUser.associatedPartyIds;
          if (assocPartyIds != null) {
            assocPartyIds = assocPartyIds.split(",");
            allOrgs = allOrgs.filter((org) =>
              assocPartyIds.includes(org.partyId)
            );
          } else {
            allOrgs = [];
          }
        }
        context.state.admin.allOrgs = allOrgs;
        context.state.admin.isLoading = false;
      })
      .catch((error) => {
        context.state.admin.isLoading = false;
        context.state.admin.isError = true;
        const status = error.response ? error.response.status : null;
        if (status === 401) {
          console.warn("Session expired while loading institutions.");
        } else {
          console.error(
            "Failed to load institutions:",
            error.message || error
          );
        }
      });
  },
  setAllConsortia: (context) => {
    console.log("ACTION: setAllConsortia");
    axios
      .get("/party/consortium", { headers: authHeader() })
      .then((response) => {
        context.state.admin.allConsortia = response.data || [];
      })
      .catch((error) => {
        const status = error.response ? error.response.status : null;
        if (status === 401) {
          console.warn("Session expired while loading consortia.");
        } else {
          console.error(
            "Failed to load consortia:",
            error.message || error
          );
        }
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/admin.js